import { defineMessages } from '@sm/intl';
import PROJECT_NAME from '~app/pages/Pricing/constants/project';

const TYPE_LABEL = '[Type: Label][Vis: high] - Feature Set List Item';
const GLOBAL_BENCHMARKS = 'SurveyMonkey Global Benchmarks';
const RESPONSES_PER_YEAR = 'Number of responses';
const SHARED_LIBRARY = 'Shared library';

export default defineMessages({
  '508_accessibility': {
    id: 'Pricing.copy.Details508Accessibility',
    defaultMessage: 'Fully accessible, 508 compliant surveys',
    desc: {
      id: 'Pricing.copy.Details508Accessibility',
      message: `${TYPE_LABEL} - Details508Accessibility`,
      project: PROJECT_NAME,
    },
  },
  a_b_testing: {
    id: 'Pricing.copy.DetailsABTesting',
    defaultMessage: 'A/B test question type',
    desc: {
      id: 'Pricing.copy.DetailsABTesting',
      message: `${TYPE_LABEL} - DetailsABTesting`,
      project: PROJECT_NAME,
    },
  },
  account_control: {
    id: 'Pricing.copy.DetailsAccountControl',
    defaultMessage: 'Account control',
    desc: {
      id: 'Pricing.copy.DetailsAccountControl',
      message: `${TYPE_LABEL} - DetailsAccountControl`,
      project: PROJECT_NAME,
    },
  },
  add_users: {
    id: 'Pricing.copy.DetailsAddUsers',
    defaultMessage: 'Additional Full User Accounts',
    desc: {
      id: 'Pricing.copy.DetailsAddUsers',
      message: `${TYPE_LABEL} - DetailsAddUsers`,
      project: PROJECT_NAME,
    },
  },
  admin_dashboard: {
    id: 'Pricing.copy.DetailsAdminDashboard',
    defaultMessage: 'Admin dashboard',
    desc: {
      id: 'Pricing.copy.DetailsAdminDashboard',
      message: `${TYPE_LABEL} - DetailsAdminDashboard`,
      project: PROJECT_NAME,
    },
  },
  advanced_logic: {
    id: 'Pricing.copy.DetailsAdvancedLogic',
    defaultMessage: 'Advanced survey logic',
    desc: {
      id: 'Pricing.copy.DetailsAdvancedLogic',
      message: `${TYPE_LABEL} - DetailsAdvancedLogic`,
      project: PROJECT_NAME,
    },
  },
  advanced_survey_features: {
    id: 'Pricing.copy.DetailsAdvancedSurveyFeatures',
    defaultMessage: 'A/B testing, randomization, quotas',
    desc: {
      id: 'Pricing.copy.DetailsAdvancedSurveyFeatures',
      message: `${TYPE_LABEL} - DetailsAdvancedSurveyFeatures`,
      project: PROJECT_NAME,
    },
  },
  all_languages_supported: {
    id: 'Pricing.copy.DetailsAllLanguagesSupported',
    defaultMessage: 'All languages supported',
    desc: {
      id: 'Pricing.copy.DetailsAllLanguagesSupported',
      message: `${TYPE_LABEL} - DetailsAllLanguagesSupported`,
      project: PROJECT_NAME,
    },
  },
  analyze_can_customize_charts: {
    id: 'Pricing.copy.DetailsAnalyzeCanCustomizeCharts',
    defaultMessage: 'Generate custom charts & reports',
    desc: {
      id: 'Pricing.copy.DetailsAnalyzeCanCustomizeCharts',
      message: `${TYPE_LABEL} - DetailsAnalyzeCanCustomizeCharts`,
      project: PROJECT_NAME,
    },
  },
  analyze_can_export_hide_branding: {
    id: 'Pricing.copy.DetailsAnalyzeCanExportHideBranding',
    defaultMessage: 'Remove SurveyMonkey footer',
    desc: {
      id: 'Pricing.copy.DetailsAnalyzeCanExportHideBranding',
      message: `${TYPE_LABEL} - DetailsAnalyzeCanExportHideBranding`,
      project: PROJECT_NAME,
    },
  },
  analyze_can_share_customize_branding: {
    id: 'Pricing.copy.DetailsAnalyzeCanShareCustomizeBranding',
    defaultMessage: 'Add your logo',
    desc: {
      id: 'Pricing.copy.DetailsAnalyzeCanShareCustomizeBranding',
      message: `${TYPE_LABEL} - DetailsAnalyzeCanShareCustomizeBranding`,
      project: PROJECT_NAME,
    },
  },
  analyze_can_ta_tag: {
    id: 'Pricing.copy.DetailsAnalyzeCanTATag',
    defaultMessage: 'Tag written answers',
    desc: {
      id: 'Pricing.copy.DetailsAnalyzeCanTATag',
      message: `${TYPE_LABEL} - DetailsAnalyzeCanTATag`,
      project: PROJECT_NAME,
    },
  },
  analyze_combine_filters: {
    id: 'Pricing.copy.DetailsCombineFilters',
    defaultMessage: 'Filter & compare results',
    desc: {
      id: 'Pricing.copy.DetailsCombineFilters',
      message: `${TYPE_LABEL} - DetailsCombineFilters`,
      project: PROJECT_NAME,
    },
  },
  analyze_dashboard_password_enabled: {
    id: 'Pricing.copy.DetailsAnalyzeDashboardPasswordEnabled',
    defaultMessage: 'Dashboard: Password protection',
    desc: {
      id: 'Pricing.copy.DetailsAnalyzeDashboardPasswordEnabled',
      message: `${TYPE_LABEL} - DetailsAnalyzeDashboardPasswordEnabled`,
      project: PROJECT_NAME,
    },
  },
  analyze_export_enabled: {
    id: 'Pricing.copy.DetailsAnalyzeExportEnabled',
    defaultMessage: 'Download results as CSV, XLS or PDF',
    desc: {
      id: 'Pricing.copy.DetailsAnalyzeExportEnabled',
      message: `${TYPE_LABEL} - DetailsAnalyzeExportEnabled`,
      project: PROJECT_NAME,
    },
  },
  analyze_export_spss_enabled: {
    id: 'Pricing.copy.DetailsAnalyzeExportSpssEnabled',
    defaultMessage: 'Export to SPSS',
    desc: {
      id: 'Pricing.copy.DetailsAnalyzeExportSpssEnabled',
      message: `${TYPE_LABEL} - DetailsAnalyzeExportSpssEnabled`,
      project: PROJECT_NAME,
    },
  },
  analyze_integrations: {
    id: 'Pricing.copy.DetailsAnalyzeIntegrations',
    defaultMessage: 'Extract data',
    desc: {
      id: 'Pricing.copy.DetailsAnalyzeIntegrations',
      message: `${TYPE_LABEL} - DetailsAnalyzeIntegrations`,
      project: PROJECT_NAME,
    },
  },
  analyze_results_together: {
    id: 'Pricing.copy.DetailsAnalyzeResultsTogether',
    defaultMessage: 'Analyze results together',
    desc: {
      id: 'Pricing.copy.DetailsAnalyzeResultsTogether',
      message: `${TYPE_LABEL} - DetailsAnalyzeResultsTogether`,
      project: PROJECT_NAME,
    },
  },
  analyze_sentiment_enabled: {
    id: 'Pricing.copy.DetailsAnalyzeSentimentEnabled',
    defaultMessage: 'Sentiment analysis',
    desc: {
      id: 'Pricing.copy.DetailsAnalyzeSentimentEnabled',
      message: `${TYPE_LABEL} - DetailsAnalyzeSentimentEnabled`,
      project: PROJECT_NAME,
    },
  },
  analyze_ta_enabled: {
    id: 'Pricing.copy.DetailsAnalyzeTAEnabled',
    defaultMessage: 'Word clouds',
    desc: {
      id: 'Pricing.copy.DetailsAnalyzeTAEnabled',
      message: `${TYPE_LABEL} - DetailsAnalyzeTAEnabled`,
      project: PROJECT_NAME,
    },
  },
  analyze_trends_enabled: {
    id: 'Pricing.copy.DetailsAnalyzeTrendsEnabled',
    defaultMessage: 'Data trends',
    desc: {
      id: 'Pricing.copy.DetailsAnalyzeTrendsEnabled',
      message: `${TYPE_LABEL} - DetailsAnalyzeTrendsEnabled`,
      project: PROJECT_NAME,
    },
  },
  asset_library: {
    id: 'Pricing.copy.DetailsAssetLibrary',
    defaultMessage: SHARED_LIBRARY,
    desc: {
      id: 'Pricing.copy.DetailsAssetLibrary',
      message: `${TYPE_LABEL} - DetailsAssetLibrary`,
      project: PROJECT_NAME,
    },
  },
  base_response_count: {
    id: 'Pricing.copy.DetailsBaseResponseCount',
    defaultMessage: RESPONSES_PER_YEAR,
    desc: {
      id: 'Pricing.copy.DetailsBaseResponseCount',
      message: `${TYPE_LABEL} - DetailsBaseResponseCount`,
      project: PROJECT_NAME,
    },
  },
  benchmarks: {
    id: 'Pricing.copy.DetailsBenchmarks',
    defaultMessage: 'SurveyMonkey Industry Benchmarks',
    desc: {
      id: 'Pricing.copy.DetailsBenchmarks',
      message: `${TYPE_LABEL} - DetailsBenchmarks`,
      project: PROJECT_NAME,
    },
  },
  build_surveys_together: {
    id: 'Pricing.copy.DetailsBuildSurveysTogether',
    defaultMessage: 'Build surveys together',
    desc: {
      id: 'Pricing.copy.DetailsBuildSurveysTogether',
      message: `${TYPE_LABEL} - DetailsBuildSurveysTogether`,
      project: PROJECT_NAME,
    },
  },
  carry_forward: {
    id: 'Pricing.copy.DetailsCarryForward',
    defaultMessage: 'Carry forward responses',
    desc: {
      id: 'Pricing.copy.DetailsCarryForward',
      message: `${TYPE_LABEL} - DetailsCarryForward`,
      project: PROJECT_NAME,
    },
  },
  click_map_qt: {
    id: 'Pricing.copy.DetailsClickMapQT',
    defaultMessage: 'Click map data visualization',
    desc: {
      id: 'Pricing.copy.DetailsClickMapQT',
      message: `${TYPE_LABEL} - DetailsClickMapQT`,
      project: PROJECT_NAME,
    },
  },
  collaboration: {
    id: 'Pricing.copy.DetailsCollaboration',
    defaultMessage: 'Advanced permissions',
    desc: {
      id: 'Pricing.copy.DetailsCollaboration',
      message: `${TYPE_LABEL} - DetailsCollaboration`,
      project: PROJECT_NAME,
    },
  },
  collect_contact_information: {
    id: 'Pricing.copy.DetailsCollectContactInformation',
    defaultMessage: 'Collect contact information',
    desc: {
      id: 'Pricing.copy.DetailsCollectContactInformation',
      message: `${TYPE_LABEL} - DetailsCollectContactInformation`,
      project: PROJECT_NAME,
    },
  },
  collector_completion_url_enabled: {
    id: 'Pricing.copy.DetailsCollectorCompletionUrlEnabled',
    defaultMessage: 'Survey completion redirect',
    desc: {
      id: 'Pricing.copy.DetailsCollectorCompletionUrlEnabled',
      message: `${TYPE_LABEL} - DetailsCollectorCompletionUrlEnabled`,
      project: PROJECT_NAME,
    },
  },
  collector_create_limit: {
    id: 'Pricing.copy.DetailsCollectorCreateLimit',
    defaultMessage: 'Number of collectors',
    desc: {
      id: 'Pricing.copy.DetailsCollectorCreateLimit',
      message: `${TYPE_LABEL} - DetailsCollectorCreateLimit`,
      project: PROJECT_NAME,
    },
  },
  collector_mobile_sdk_enabled: {
    id: 'Pricing.copy.DetailsCollectorMobileSdkEnabled',
    defaultMessage: 'Mobile SDK',
    desc: {
      id: 'Pricing.copy.DetailsCollectorMobileSdkEnabled',
      message: `${TYPE_LABEL} - DetailsCollectorMobileSdkEnabled`,
      project: PROJECT_NAME,
    },
  },
  collector_popup_enabled: {
    id: 'Pricing.copy.DetailsCollectorPopupEnabled',
    defaultMessage: 'Pop up online surveys',
    desc: {
      id: 'Pricing.copy.DetailsCollectorPopupEnabled',
      message: `${TYPE_LABEL} - DetailsCollectorPopupEnabled`,
      project: PROJECT_NAME,
    },
  },
  collector_friendly_url_enabled: {
    id: 'Pricing.copy.DetailsCollectorFriendlyUrlEnabled',
    defaultMessage: 'Custom SurveyMonkey URL',
    desc: {
      id: 'Pricing.copy.DetailsCollectorFriendlyUrlEnabled',
      message: `${TYPE_LABEL} - DetailsCollectorFriendlyUrlEnabled`,
      project: PROJECT_NAME,
    },
  },
  collector_thank_you_enabled: {
    id: 'Pricing.copy.DetailsCollectorThankYouEnabled',
    defaultMessage: `Display a 'thank you' page`,
    desc: {
      id: 'Pricing.copy.DetailsCollectorThankYouEnabled',
      message: `${TYPE_LABEL} - DetailsCollectorThankYouEnabled`,
      project: PROJECT_NAME,
    },
  },
  collector_white_label_enabled: {
    id: 'Pricing.copy.DetailsCollectorWhiteLabelEnabled',
    defaultMessage: 'White label surveys',
    desc: {
      id: 'Pricing.copy.DetailsCollectorWhiteLabelEnabled',
      message: `${TYPE_LABEL} - DetailsCollectorWhiteLabelEnabled`,
      project: PROJECT_NAME,
    },
  },
  consolidated_billing: {
    id: 'Pricing.copy.DetailsConsolidatedBilling',
    defaultMessage: 'Consolidated billing',
    desc: {
      id: 'Pricing.copy.DetailsConsolidatedBilling',
      message: `${TYPE_LABEL} - DetailsConsolidatedBilling`,
      project: PROJECT_NAME,
    },
  },
  contributor_seats: {
    id: 'Pricing.copy.DetailsContributorSeats',
    defaultMessage: 'Contributor Seats',
    desc: {
      id: 'Pricing.copy.DetailsContributorSeats',
      message: `${TYPE_LABEL} - DetailsContributorSeats`,
      project: PROJECT_NAME,
    },
  },
  create_custom_html_email_message_enabled: {
    id: 'Pricing.copy.DetailsCreateCustomHtmlEmailMessageEnabled',
    defaultMessage: 'Custom HTML email invitations',
    desc: {
      id: 'Pricing.copy.DetailsCreateCustomHtmlEmailMessageEnabled',
      message: `${TYPE_LABEL} - DetailsCreateCustomHtmlEmailMessageEnabled`,
      project: PROJECT_NAME,
    },
  },
  create_custom_theme_enabled: {
    id: 'Pricing.copy.DetailsCreateCustomThemeEnabled',
    defaultMessage: 'Custom themes, colors & more',
    desc: {
      id: 'Pricing.copy.DetailsCreateCustomThemeEnabled',
      message: `${TYPE_LABEL} - DetailsCreateCustomThemeEnabled`,
      project: PROJECT_NAME,
    },
  },
  create_custom_variables_enabled: {
    id: 'Pricing.copy.DetailsCreateCustomVariablesEnabled',
    defaultMessage: 'Custom variables',
    desc: {
      id: 'Pricing.copy.DetailsCreateCustomVariablesEnabled',
      message: `${TYPE_LABEL} - DetailsCreateCustomVariablesEnabled`,
      project: PROJECT_NAME,
    },
  },
  create_grayscale_footer: {
    id: 'Pricing.copy.DetailsCreateGrayscaleFooter',
    defaultMessage: 'Subtle SurveyMonkey footer',
    desc: {
      id: 'Pricing.copy.DetailsCreateGrayscaleFooter',
      message: `${TYPE_LABEL} - DetailsCreateGrayscaleFooter`,
      project: PROJECT_NAME,
    },
  },
  create_logo_enabled: {
    id: 'Pricing.copy.DetailsCreateLogoEnabled',
    defaultMessage: 'Add your logo',
    desc: {
      id: 'Pricing.copy.DetailsCreateLogoEnabled',
      message: `${TYPE_LABEL} - `,
      project: PROJECT_NAME,
    },
  },
  create_piping_enabled: {
    id: 'Pricing.copy.DetailsCreatePipingEnabled',
    defaultMessage: 'Question & answer piping',
    desc: {
      id: 'Pricing.copy.DetailsCreatePipingEnabled',
      message: `${TYPE_LABEL} - DetailsCreatePipingEnabled`,
      project: PROJECT_NAME,
    },
  },
  create_print_enabled: {
    id: 'Pricing.copy.DetailsCreatePrintEnabled',
    defaultMessage: 'Print reports',
    desc: {
      id: 'Pricing.copy.DetailsCreatePrintEnabled',
      message: `${TYPE_LABEL} - DetailsCreatePrintEnabled`,
      project: PROJECT_NAME,
    },
  },
  create_question_limit: {
    id: 'Pricing.copy.DetailsCreateQuestionLimit',
    defaultMessage: 'Questions per survey',
    desc: {
      id: 'Pricing.copy.DetailsCreateQuestionLimit',
      message: `${TYPE_LABEL} - DetailsCreateQuestionLimit`,
      project: PROJECT_NAME,
    },
  },
  create_quotas_enabled: {
    id: 'Pricing.copy.DetailsCreateQuotasEnabled',
    defaultMessage: 'Response quotas',
    desc: {
      id: 'Pricing.copy.DetailsCreateQuotasEnabled',
      message: `${TYPE_LABEL} - DetailsCreateQuotasEnabled`,
      project: PROJECT_NAME,
    },
  },
  create_randomization_enabled: {
    id: 'Pricing.copy.DetailsCreateRandomizationEnabled',
    defaultMessage: 'Question & page randomization',
    desc: {
      id: 'Pricing.copy.DetailsCreateRandomizationEnabled',
      message: `${TYPE_LABEL} - DetailsCreateRandomizationEnabled`,
      project: PROJECT_NAME,
    },
  },
  create_skip_logic_enabled: {
    id: 'Pricing.copy.DetailsCreateSkipLogicEnabled',
    defaultMessage: 'Question & page skip logic',
    desc: {
      id: 'Pricing.copy.DetailsCreateSkipLogicEnabled',
      message: `${TYPE_LABEL} - DetailsCreateSkipLogicEnabled`,
      project: PROJECT_NAME,
    },
  },
  create_templates_enabled: {
    id: 'Pricing.copy.DetailsCreateTemplatesEnabled',
    defaultMessage: 'Expert, pre-written survey templates',
    desc: {
      id: 'Pricing.copy.DetailsCreateTemplatesEnabled',
      message: `${TYPE_LABEL} - DetailsCreateTemplatesEnabled`,
      project: PROJECT_NAME,
    },
  },
  create_toggle_footer_enabled: {
    id: 'Pricing.copy.DetailsCreateToggleFooterEnabled',
    defaultMessage: 'Remove SurveyMonkey footer',
    desc: {
      id: 'Pricing.copy.DetailsCreateToggleFooterEnabled',
      message: `${TYPE_LABEL} - DetailsCreateToggleFooterEnabled`,
      project: PROJECT_NAME,
    },
  },
  custom_question_bank: {
    id: 'Pricing.copy.DetailsCustomQuestionBank',
    defaultMessage: 'Custom Question Bank',
    desc: {
      id: 'Pricing.copy.DetailsCustomQuestionBank',
      message: `${TYPE_LABEL} - DetailsCustomQuestionBank`,
      project: PROJECT_NAME,
    },
  },
  custom_subdomain: {
    id: 'Pricing.copy.DetailsCustomSubdomain',
    defaultMessage: 'Custom subdomain',
    desc: {
      id: 'Pricing.copy.DetailsCustomSubdomain',
      message: `${TYPE_LABEL} - DetailsCustomSubdomain`,
      project: PROJECT_NAME,
    },
  },
  custom_templates: {
    id: 'Pricing.copy.DetailsCustomTemplates',
    defaultMessage: 'Shared templates',
    desc: {
      id: 'Pricing.copy.DetailsCustomTemplates',
      message: `${TYPE_LABEL} - DetailsCustomTemplates`,
      project: PROJECT_NAME,
    },
  },
  custom_terms_of_use: {
    id: 'Pricing.copy.DetailsCustomTermsOfUse',
    defaultMessage: 'Custom Terms of Use',
    desc: {
      id: 'Pricing.copy.DetailsCustomTermsOfUse',
      message: `${TYPE_LABEL} - DetailsCustomTermsOfUse`,
      project: PROJECT_NAME,
    },
  },
  customize_disqualification_page_enabled: {
    id: 'Pricing.copy.DetailsCustomizeDisqualificationPageEnabled',
    defaultMessage: 'Display disqualification page',
    desc: {
      id: 'Pricing.copy.DetailsCustomizeDisqualificationPageEnabled',
      message: `${TYPE_LABEL} - DetailsCustomizeDisqualificationPageEnabled`,
      project: PROJECT_NAME,
    },
  },
  customer_success_manager: {
    id: 'Pricing.copy.DetailsCustomerSuccessManager',
    defaultMessage: 'Customer Success Manager',
    desc: {
      id: 'Pricing.copy.DetailsCustomerSuccessManager',
      message: `${TYPE_LABEL} - DetailsCustomerSuccessManager`,
      project: PROJECT_NAME,
    },
  },
  dashboard: {
    id: 'Pricing.copy.DetailsDashboard',
    defaultMessage: 'Dashboard',
    desc: {
      id: 'Pricing.copy.DetailsDashboard',
      message: `${TYPE_LABEL} - DetailsDashboard`,
      project: PROJECT_NAME,
    },
  },
  download_as_ppt: {
    id: 'Pricing.copy.DetailsDownloadAsPpt',
    defaultMessage: 'Download results in PPT format',
    desc: {
      id: 'Pricing.copy.DetailsDownloadAsPpt',
      message: `${TYPE_LABEL} - DetailsDownloadAsPpt`,
      project: PROJECT_NAME,
    },
  },
  email_support: {
    id: 'Pricing.copy.DetailsEmailSupport',
    defaultMessage: '24/7 email support',
    desc: {
      id: 'Pricing.copy.DetailsEmailSupport',
      message: `${TYPE_LABEL} - DetailsEmailSupport`,
      project: PROJECT_NAME,
    },
  },
  enable_ip_blocking: {
    id: 'Pricing.copy.DetailsEnableIpBlocking',
    defaultMessage: 'Enable IP Blocking',
    desc: {
      id: 'Pricing.copy.DetailsEnableIpBlocking',
      message: `${TYPE_LABEL} - DetailsEnableIpBlocking`,
      project: PROJECT_NAME,
    },
  },
  essential_question_types: {
    id: 'Pricing.copy.DetailsEssentialQuestionTypes',
    defaultMessage: 'Essential question types',
    desc: {
      id: 'Pricing.copy.DetailsEssentialQuestionTypes',
      message: `${TYPE_LABEL} - DetailsEssentialQuestionTypes`,
      project: PROJECT_NAME,
    },
  },
  extract_data: {
    id: 'Pricing.copy.DetailsExtractData',
    defaultMessage: 'Extract data',
    desc: {
      id: 'Pricing.copy.DetailsExtractData',
      message: `${TYPE_LABEL} - DetailsExtractData`,
      project: PROJECT_NAME,
    },
  },
  file_upload: {
    id: 'Pricing.copy.DetailsFileUpload',
    defaultMessage: 'File upload',
    desc: {
      id: 'Pricing.copy.DetailsFileUpload',
      message: `${TYPE_LABEL} - DetailsFileUpload`,
      project: PROJECT_NAME,
    },
  },
  global_settings: {
    id: 'Pricing.copy.DetailsGlobalSettings',
    defaultMessage: 'Global settings',
    desc: {
      id: 'Pricing.copy.DetailsGlobalSettings',
      message: `${TYPE_LABEL} - DetailsGlobalSettings`,
      project: PROJECT_NAME,
    },
  },
  hipaa_enabled: {
    id: 'Pricing.copy.DetailsHipaaEnabled',
    defaultMessage: 'HIPAA-compliant features',
    desc: {
      id: 'Pricing.copy.DetailsHipaaEnabled',
      message: `${TYPE_LABEL} - DetailsHipaaEnabled`,
      project: PROJECT_NAME,
    },
  },
  enterprise_only_integrations: {
    id: 'Pricing.copy.DetailsEnterpriseOnlyIntegrations',
    defaultMessage: 'Enterprise-only integrations',
    desc: {
      id: 'Pricing.copy.DetailsEnterpriseOnlyIntegrations',
      message: `${TYPE_LABEL} - DetailsEnterpriseOnlyIntegrations`,
      project: PROJECT_NAME,
    },
  },
  kiosk_mode_inactivity_timer: {
    id: 'Pricing.copy.DetailsKioskModeInactivityTimer',
    defaultMessage: 'Kiosk Mode: Inactivity Timer',
    desc: {
      id: 'Pricing.copy.DetailsKioskModeInactivityTimer',
      message: `${TYPE_LABEL} - DetailsKioskModeInactivityTimer`,
      project: PROJECT_NAME,
    },
  },
  kiosk_mode_passcode_lock: {
    id: 'Pricing.copy.DetailsKioskModePasscodeLock',
    defaultMessage: 'Kiosk Mode: Passcode Lock',
    desc: {
      id: 'Pricing.copy.DetailsKioskModePasscodeLock',
      message: `${TYPE_LABEL} - DetailsKioskModePasscodeLock`,
      project: PROJECT_NAME,
    },
  },
  labeling_titles_numbering: {
    id: 'Pricing.copy.DetailsLabelingTitlesNumbering',
    defaultMessage: 'Labeling, titles & numbering',
    desc: {
      id: 'Pricing.copy.DetailsLabelingTitlesNumbering',
      message: `${TYPE_LABEL} - DetailsLabelingTitlesNumbering`,
      project: PROJECT_NAME,
    },
  },
  matrix_question_type: {
    id: 'Pricing.copy.DetailsMatrixQuestionType',
    defaultMessage: 'Matrix questions',
    desc: {
      id: 'Pricing.copy.DetailsMatrixQuestionType',
      message: `${TYPE_LABEL} - DetailsMatrixQuestionType`,
      project: PROJECT_NAME,
    },
  },
  menu_matrix_enabled: {
    id: 'Pricing.copy.DetailsMenuMatrixEnabled',
    defaultMessage: 'Matrix of dropdown menus',
    desc: {
      id: 'Pricing.copy.DetailsMenuMatrixEnabled',
      message: `${TYPE_LABEL} - DetailsMenuMatrixEnabled`,
      project: PROJECT_NAME,
    },
  },
  mobile_apps_ios_android: {
    id: 'Pricing.copy.DetailsMobileAppsIOSAndAndroid',
    defaultMessage: 'Mobile apps for iOS and Android',
    desc: {
      id: 'Pricing.copy.DetailsMobileAppsIOSAndAndroid',
      message: `${TYPE_LABEL} - DetailsMobileAppsIOSAndAndroid`,
      project: PROJECT_NAME,
    },
  },
  mobile_sdk_pull_response_data_enabled: {
    id: 'Pricing.copy.DetailsMobileSdkPullResponseDataEnabled',
    defaultMessage: 'Mobile SDK - Data Pull',
    desc: {
      id: 'Pricing.copy.DetailsMobileSdkPullResponseDataEnabled',
      message: `${TYPE_LABEL} - DetailsMobileSdkPullResponseDataEnabled`,
      project: PROJECT_NAME,
    },
  },
  multilingual: {
    id: 'Pricing.copy.DetailsMultilingual',
    defaultMessage: 'Multilingual surveys',
    desc: {
      id: 'Pricing.copy.DetailsMultilingual',
      message: `${TYPE_LABEL} - DetailsMultilingual`,
      project: PROJECT_NAME,
    },
  },
  multiple_block_rotation_enabled: {
    id: 'Pricing.copy.DetailsMultipleBlockRotationEnabled',
    defaultMessage: 'Block randomization',
    desc: {
      id: 'Pricing.copy.DetailsMultipleBlockRotationEnabled',
      message: `${TYPE_LABEL} - DetailsMultipleBlockRotationEnabled`,
      project: PROJECT_NAME,
    },
  },
  num_free_responses: {
    id: 'Pricing.copy.DetailsNumFreeResponses',
    defaultMessage: RESPONSES_PER_YEAR,
    desc: {
      id: 'Pricing.copy.DetailsNumFreeResponses',
      message: `${TYPE_LABEL} - DetailsNumFreeResponses`,
      project: PROJECT_NAME,
    },
  },
  onboarding: {
    id: 'Pricing.copy.DetailsOnboarding',
    defaultMessage: 'Onboarding',
    desc: {
      id: 'Pricing.copy.DetailsOnboarding',
      message: `${TYPE_LABEL} - DetailsOnboarding`,
      project: PROJECT_NAME,
    },
  },
  pagination: {
    id: 'Pricing.copy.DetailsPagination',
    defaultMessage: 'Pagination',
    desc: {
      id: 'Pricing.copy.DetailsPagination',
      message: `${TYPE_LABEL} - DetailsPagination`,
      project: PROJECT_NAME,
    },
  },
  password_protection: {
    id: 'Pricing.copy.DetailsPasswordProtection',
    defaultMessage: 'Password-protected surveys',
    desc: {
      id: 'Pricing.copy.DetailsPasswordProtection',
      message: `${TYPE_LABEL} - DetailsPasswordProtection`,
      project: PROJECT_NAME,
    },
  },
  payment_qt: {
    id: 'Pricing.copy.DetailsPaymentQT',
    defaultMessage: 'Accept payments',
    desc: {
      id: 'Pricing.copy.DetailsPaymentQT',
      message: `${TYPE_LABEL} - DetailsPaymentQT`,
      project: PROJECT_NAME,
    },
  },
  phone_support: {
    id: 'Pricing.copy.DetailsPhoneSupport',
    defaultMessage: 'Phone support',
    desc: {
      id: 'Pricing.copy.DetailsPhoneSupport',
      message: `${TYPE_LABEL} - DetailsPhoneSupport`,
      project: PROJECT_NAME,
    },
  },
  plans_benchmarks: {
    id: 'Pricing.copy.DetailsPlansBenchmark',
    defaultMessage: GLOBAL_BENCHMARKS,
    desc: {
      id: 'Pricing.copy.DetailsPlansBenchmark',
      message: `${TYPE_LABEL} - DetailsPlansBenchmark`,
      project: PROJECT_NAME,
    },
  },
  pop_up_collector: {
    id: 'Pricing.copy.DetailsPopupCollector',
    defaultMessage: 'Pop up online surveys',
    desc: {
      id: 'Pricing.copy.DetailsPopupCollector',
      message: `${TYPE_LABEL} - DetailsPopupCollector`,
      project: PROJECT_NAME,
    },
  },
  premium_themes: {
    id: 'Pricing.copy.DetailsPremiumThemes',
    defaultMessage: 'Premium themes',
    desc: {
      id: 'Pricing.copy.DetailsPremiumThemes',
      message: `${TYPE_LABEL} - DetailsPremiumThemes`,
      project: PROJECT_NAME,
    },
  },
  priority_email_support: {
    id: 'Pricing.copy.DetailsPrimaryEmailSupport',
    defaultMessage: 'Expedited email support',
    desc: {
      id: 'Pricing.copy.DetailsPrimaryEmailSupport',
      message: `${TYPE_LABEL} - DetailsPrimaryEmailSupport`,
      project: PROJECT_NAME,
    },
  },
  private_apps: {
    id: 'Pricing.copy.DetailsPrivateApps',
    defaultMessage: 'Unlimited API access',
    desc: {
      id: 'Pricing.copy.DetailsPrivateApps',
      message: `${TYPE_LABEL} - DetailsPrivateApps`,
      project: PROJECT_NAME,
    },
  },
  progress_bar: {
    id: 'Pricing.copy.DetailsProgressBar',
    defaultMessage: 'Progress bar',
    desc: {
      id: 'Pricing.copy.DetailsProgressBar',
      message: `${TYPE_LABEL} - DetailsProgressBar`,
      project: PROJECT_NAME,
    },
  },
  question_library: {
    id: 'Pricing.copy.DetailsQuestionLibrary',
    defaultMessage: 'Question Bank approved questions',
    desc: {
      id: 'Pricing.copy.DetailsQuestionLibrary',
      message: `${TYPE_LABEL} - DetailsQuestionLibrary`,
      project: PROJECT_NAME,
    },
  },
  quiz_scoring_and_instant_results: {
    id: 'Pricing.copy.DetailsQuizScoring',
    defaultMessage: 'Quiz scoring & instant results',
    desc: {
      id: 'Pricing.copy.DetailsQuizScoring',
      message: `${TYPE_LABEL} - DetailsQuizScoring`,
      project: PROJECT_NAME,
    },
  },
  quizzes_pro: {
    id: 'Pricing.copy.DetailsQuizzesPro',
    defaultMessage: 'Quizzes pro',
    desc: {
      id: 'Pricing.copy.DetailsQuizzesPro',
      message: `${TYPE_LABEL} - DetailsQuizzesPro`,
      project: PROJECT_NAME,
    },
  },
  randomize_answer_choices: {
    id: 'Pricing.copy.DetailsRandomizeAnswerChoices',
    defaultMessage: 'Randomize answer choices',
    desc: {
      id: 'Pricing.copy.DetailsRandomizeAnswerChoices',
      message: `${TYPE_LABEL} - DetailsRandomizeAnswerChoices`,
      project: PROJECT_NAME,
    },
  },
  ranking_question_type: {
    id: 'Pricing.copy.DetailsRankingQuestionType',
    defaultMessage: 'Ranking questions',
    desc: {
      id: 'Pricing.copy.DetailsRankingQuestionType',
      message: `${TYPE_LABEL} - DetailsRankingQuestionType`,
      project: PROJECT_NAME,
    },
  },
  rating_question_type: {
    id: 'Pricing.copy.DetailsRatingQuestionType',
    defaultMessage: 'Rating questions',
    desc: {
      id: 'Pricing.copy.DetailsRatingQuestionType',
      message: `${TYPE_LABEL} - DetailsRatingQuestionType`,
      project: PROJECT_NAME,
    },
  },
  real_time_results: {
    id: 'Pricing.copy.DetailsRealTimeResults',
    defaultMessage: 'Real time results',
    desc: {
      id: 'Pricing.copy.DetailsRealTimeResults',
      message: `${TYPE_LABEL} - DetailsRealTimeResults`,
      project: PROJECT_NAME,
    },
  },
  record_respondent_email_address: {
    id: 'Pricing.copy.DetailsRecordRespondentEmailAddress',
    defaultMessage: 'Record respondent email address',
    desc: {
      id: 'Pricing.copy.DetailsRecordRespondentEmailAddress',
      message: `${TYPE_LABEL} - DetailsRecordRespondentEmailAddress`,
      project: PROJECT_NAME,
    },
  },
  recurring_surveys: {
    id: 'Pricing.copy.DetailsRecurringSurveys',
    defaultMessage: 'Recurring surveys',
    desc: {
      id: 'Pricing.copy.DetailsRecurringSurveys',
      message: `${TYPE_LABEL} - DetailsRecurringSurveys`,
      project: PROJECT_NAME,
    },
  },
  require_answer: {
    id: 'Pricing.copy.DetailsRequireAnswer',
    defaultMessage: 'Require answer completion',
    desc: {
      id: 'Pricing.copy.DetailsRequireAnswer',
      message: `${TYPE_LABEL} - DetailsRequireAnswer`,
      project: PROJECT_NAME,
    },
  },
  respondent_receipt: {
    id: 'Pricing.copy.DetailsRespondentReceipt',
    defaultMessage: 'Confirmation Email to Respondents',
    desc: {
      id: 'Pricing.copy.DetailsRespondentReceipt',
      message: `${TYPE_LABEL} - DetailsRespondentReceipt`,
      project: PROJECT_NAME,
    },
  },
  response_quality_enabled: {
    id: 'Pricing.copy.DetailsResponseQualityEnabled',
    defaultMessage: 'Response Quality',
    desc: {
      id: 'Pricing.copy.DetailsResponseQualityEnabled',
      message: `${TYPE_LABEL} - DetailsResponseQualityEnabled`,
      project: PROJECT_NAME,
    },
  },
  send_surveys: {
    id: 'Pricing.copy.DetailsSendSurveys',
    defaultMessage: 'Send Surveys',
    desc: {
      id: 'Pricing.copy.DetailsSendSurveys',
      message: `${TYPE_LABEL} - DetailsSendSurveys`,
      project: PROJECT_NAME,
    },
  },
  set_max_response_count: {
    id: 'Pricing.copy.DetailsSetMaxResponseCount',
    defaultMessage: 'Set Max Response Count',
    desc: {
      id: 'Pricing.copy.DetailsSetMaxResponseCount',
      message: `${TYPE_LABEL} - DetailsSetMaxResponseCount`,
      project: PROJECT_NAME,
    },
  },
  set_survey_end_date: {
    id: 'Pricing.copy.DetailsSetSurveyEndDate',
    defaultMessage: 'Set survey end date',
    desc: {
      id: 'Pricing.copy.DetailsSetSurveyEndDate',
      message: `${TYPE_LABEL} - DetailsSetSurveyEndDate`,
      project: PROJECT_NAME,
    },
  },
  share_surveys: {
    id: 'Pricing.copy.DetailsShareSurveys',
    defaultMessage: 'Share survey data',
    desc: {
      id: 'Pricing.copy.DetailsShareSurveys',
      message: `${TYPE_LABEL} - DetailsShareSurveys`,
      project: PROJECT_NAME,
    },
  },
  shared_library: {
    id: 'Pricing.copy.DetailsSharedLibrary',
    defaultMessage: SHARED_LIBRARY,
    desc: {
      id: 'Pricing.copy.DetailsSharedLibrary',
      message: `${TYPE_LABEL} - DetailsSharedLibrary`,
      project: PROJECT_NAME,
    },
  },
  show_create_crosstab: {
    id: 'Pricing.copy.DetailsShowCreateCrosstab',
    defaultMessage: 'Crosstabs',
    desc: {
      id: 'Pricing.copy.DetailsShowCreateCrosstab',
      message: `${TYPE_LABEL} - DetailsShowCreateCrosstab`,
      project: PROJECT_NAME,
    },
  },
  show_sig_diffs_enabled: {
    id: 'Pricing.copy.DetailsShowSigDiffsEnabled',
    defaultMessage: 'Statistical significance',
    desc: {
      id: 'Pricing.copy.DetailsShowSigDiffsEnabled',
      message: `${TYPE_LABEL} - DetailsShowSigDiffsEnabled`,
      project: PROJECT_NAME,
    },
  },
  single_sign_on: {
    id: 'Pricing.copy.DetailsSingleSignOn',
    defaultMessage: 'Single sign-on',
    desc: {
      id: 'Pricing.copy.DetailsSingleSignOn',
      message: `${TYPE_LABEL} - DetailsSingleSignOn`,
      project: PROJECT_NAME,
    },
  },
  slider_question_type: {
    id: 'Pricing.copy.DetailsSliderQuestionType',
    defaultMessage: 'Slider questions',
    desc: {
      id: 'Pricing.copy.DetailsSliderQuestionType',
      message: `${TYPE_LABEL} - DetailsSliderQuestionType`,
      project: PROJECT_NAME,
    },
  },
  survey_branding: {
    id: 'Pricing.copy.DetailsSurveyBranding',
    defaultMessage: 'Custom logo, colors, and survey URL',
    desc: {
      id: 'Pricing.copy.DetailsSurveyBranding',
      message: `${TYPE_LABEL} - DetailsSurveyBranding`,
      project: PROJECT_NAME,
    },
  },
  survey_create_limit: {
    id: 'Pricing.copy.DetailsSurveyCreateLimit',
    defaultMessage: 'Number of surveys',
    desc: {
      id: 'Pricing.copy.DetailsSurveyCreateLimit',
      message: `${TYPE_LABEL} - DetailsSurveyCreateLimit`,
      project: PROJECT_NAME,
    },
  },
  team_activity: {
    id: 'Pricing.copy.DetailsTeamActivity',
    defaultMessage: 'Team activity',
    desc: {
      id: 'Pricing.copy.DetailsTeamActivity',
      message: `${TYPE_LABEL} - DetailsTeamActivity`,
      project: PROJECT_NAME,
    },
  },
  team_ownership: {
    id: 'Pricing.copy.DetailsTeamOwnership',
    defaultMessage: 'Team ownership',
    desc: {
      id: 'Pricing.copy.DetailsTeamOwnership',
      message: `${TYPE_LABEL} - DetailsTeamOwnership`,
      project: PROJECT_NAME,
    },
  },
  team_themes: {
    id: 'Pricing.copy.DetailsTeamThemes',
    defaultMessage: 'Shared themes',
    desc: {
      id: 'Pricing.copy.DetailsTeamThemes',
      message: `${TYPE_LABEL} - DetailsTeamThemes`,
      project: PROJECT_NAME,
    },
  },
  text_analysis: {
    id: 'Pricing.copy.DetailsTextAnalysis',
    defaultMessage: 'Text analysis',
    desc: {
      id: 'Pricing.copy.DetailsTextAnalysis',
      message: `${TYPE_LABEL} - DetailsTextAnalysis`,
      project: PROJECT_NAME,
    },
  },
  text_formatting: {
    id: 'Pricing.copy.DetailsTextFormatting',
    defaultMessage: 'Text formatting',
    desc: {
      id: 'Pricing.copy.DetailsTextFormatting',
      message: `${TYPE_LABEL} - DetailsTextFormatting`,
      project: PROJECT_NAME,
    },
  },
  track_email_responses: {
    id: 'Pricing.copy.DetailsTrackEmailResponses',
    defaultMessage: 'Track Email Responses',
    desc: {
      id: 'Pricing.copy.DetailsTrackEmailResponses',
      message: `${TYPE_LABEL} - DetailsTrackEmailResponses`,
      project: PROJECT_NAME,
    },
  },
  unlimited_responses: {
    id: 'Pricing.copy.DetailsUnlimitedResponses',
    defaultMessage: 'Unlimited surveys and questions',
    desc: {
      id: 'Pricing.copy.DetailsUnlimitedResponses',
      message: `${TYPE_LABEL} - DetailsUnlimitedResponses`,
      project: PROJECT_NAME,
    },
  },
  user_management: {
    id: 'Pricing.copy.DetailsUserManagement',
    defaultMessage: 'Additional Users',
    desc: {
      id: 'Pricing.copy.DetailsUserManagement',
      message: `${TYPE_LABEL} - DetailsUserManagement`,
      project: PROJECT_NAME,
    },
  },
  validate_answer: {
    id: 'Pricing.copy.DetailsValidateAnswer',
    defaultMessage: 'Answer validation',
    desc: {
      id: 'Pricing.copy.DetailsValidateAnswer',
      message: `${TYPE_LABEL} - DetailsValidateAnswer`,
      project: PROJECT_NAME,
    },
  },
  video_question_type: {
    id: 'Pricing.copy.DetailsVideoQuestionType',
    defaultMessage: 'Video and image questions',
    desc: {
      id: 'Pricing.copy.DetailsVideoQuestionType',
      message: `${TYPE_LABEL} - DetailsVideoQuestionType`,
      project: PROJECT_NAME,
    },
  },
  view_respondent_ip_address: {
    id: 'Pricing.copy.DetailsViewRespondentIpAddress',
    defaultMessage: `View respondent's IP address`,
    desc: {
      id: 'Pricing.copy.DetailsViewRespondentIpAddress',
      message: `${TYPE_LABEL} - DetailsViewRespondentIpAddress`,
      project: PROJECT_NAME,
    },
  },
  web_social_email_responses: {
    id: 'Pricing.copy.DetailsWebSocialEmailResponses',
    defaultMessage: 'Get responses via web, social or email',
    desc: {
      id: 'Pricing.copy.DetailsWebSocialEmailResponses',
      message: `${TYPE_LABEL} - DetailsWebSocialEmailResponses`,
      project: PROJECT_NAME,
    },
  },
  word_cloud_combine_hide: {
    id: 'Pricing.copy.DetailsWordCloudCombineHide',
    defaultMessage: 'Word clouds: Combine or hide words',
    desc: {
      id: 'Pricing.copy.DetailsWordCloudCombineHide',
      message: `${TYPE_LABEL} - DetailsWordCloudCombineHide`,
      project: PROJECT_NAME,
    },
  },
});
